package app.nestbridge.feature.profile.screen

import com.karawek.core.circuit.Parcelize
import androidx.compose.runtime.Immutable
import com.karawek.core.auth.model.AuthenticatedUser
import com.slack.circuit.runtime.CircuitUiState
import com.slack.circuit.runtime.screen.PopResult
import com.slack.circuit.runtime.screen.Screen

@Parcelize
data class CreateUserProfileScreen(
    val prefillName: String? = null,
    val relayEmail: String? = null,
    val createUserProfileUserInfo: CreateUserProfileUserInfo? = null,
) : Screen

@Parcelize
data class CreateUserProfileUserInfo(
    val firstName: String? = null,
    val middleName: String? = null,
    val lastName: String? = null,
    val emailAddresses: List<String> = emptyList(),
    val phoneNumbers: List<String> = emptyList(),
) : Screen {
    companion object {
        fun from(
            info: AuthenticatedUser,
        ): CreateUserProfileUserInfo = CreateUserProfileUserInfo(
            firstName = info.firstName,
            middleName = info.middleName,
            lastName = info.lastName,
            emailAddresses = info.emailAddresses,
            phoneNumbers = info.phoneNumbers,
        )
    }
}

@Parcelize
data class CreateUserProfileResult(
    val status: Status,
) : PopResult {
    enum class Status { Completed }
}

@Immutable
data class CreateUserProfileState(
    val fullName: String = "",
    val phoneNumber: String = "",
    val emailAddress: String = "",
    val relayEmail: String? = null,

    val phoneStatus: VerificationStatus = VerificationStatus.Unverified,
    val emailStatus: VerificationStatus = VerificationStatus.Unverified,

    val isSaving: Boolean = false,
    val errorMessage: String? = null,

    val eventSink: (CreateUserProfileEvent) -> Unit = {},
) : CircuitUiState

enum class VerificationStatus {
    Unverified,
    Pending,
    Verified,
}

sealed interface CreateUserProfileEvent {
    data object OnAppear : CreateUserProfileEvent

    data class UpdateFullName(val value: String) : CreateUserProfileEvent
    data class UpdatePhoneNumber(val value: String) : CreateUserProfileEvent
    data class UpdateEmailAddress(val value: String) : CreateUserProfileEvent

    data object VerifyPhone : CreateUserProfileEvent
    data object VerifyEmail : CreateUserProfileEvent

    data object Continue : CreateUserProfileEvent
    data object DismissError : CreateUserProfileEvent
}

fun CreateUserProfileState.canContinue(): Boolean =
    fullName.trim().isNotEmpty()
